import { useMemo, useState } from 'react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import Loading from '@/components/Loading'
import { usePlatformAuditInfinite } from '@/hooks/usePlatformAudit'

export default function PlatformAuditPage() {
  const [q, setQ] = useState('')
  const [apply, setApply] = useState('')

  const filters = useMemo(() => ({ q: apply || undefined }), [apply])
  const { data, isPending, fetchNextPage, hasNextPage, isFetchingNextPage } =
    usePlatformAuditInfinite(filters)

  const items = data?.pages.flatMap((p) => p.items) ?? []

  return (
    <Card>
      <CardHeader>
        <h2 className='text-xl font-semibold'>Audit</h2>
        <p className='text-sm text-muted-foreground'>
          Recherche par action / path / targetId
        </p>
      </CardHeader>
      <CardContent>
        <div className='flex items-center gap-2'>
          <Input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder='ex: PLAN_FORCE / /platform/billing'
          />
          <Button onClick={() => setApply(q.trim())}>Rechercher</Button>
        </div>

        <div className='mt-4'>
          {isPending ? (
            <Loading />
          ) : (
            <div className='space-y-2'>
              {items.map((row) => (
                <div key={row.id} className='rounded-lg border p-3'>
                  <div className='flex items-center justify-between'>
                    <div className='font-medium'>{row.action}</div>
                    <div className='text-xs text-muted-foreground'>
                      {new Date(row.createdAt).toLocaleString()}
                    </div>
                  </div>
                  <div className='text-xs text-muted-foreground mt-1'>
                    target: {row.targetType} {row.targetId ?? '—'} • actor:{' '}
                    {row.actor.email} ({row.actor.role})
                  </div>
                  <div className='text-xs text-muted-foreground mt-1'>
                    {row.method ?? '—'} {row.path ?? '—'} • ip: {row.ip ?? '—'}
                  </div>
                </div>
              ))}

              {hasNextPage && (
                <div className='pt-2'>
                  <Button
                    variant='outline'
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                  >
                    {isFetchingNextPage ? 'Chargement…' : 'Charger plus'}
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
